<template>
  <div class="main-dashboard-layout">
    <div>
      <v-row class="white mx-0 mb-4 px-4 pt-4 pb-0 list-box-Shadow">
        <v-col cols="7" class="d-flex align-center">
          <span
            class="text-h5 text-uppercase font-weight-bold text_color--text"
          >
            {{ clientDashboardModule.dashboard }}
          </span>
        </v-col>
      </v-row>
    </div>
    <v-row
      class="ma-0"
      
      v-if="dashboardStatistics && Object.keys(dashboardStatistics).length > 0"
    >
      <v-col
        cols="12"
        md="6"
        lg="2"
        class="pl-md-2 pr-md-1 pa-sm-2"
        v-if="dashboardStatistics.trip_stats"
      >
        <v-card
          class="rounded-lg"
          flat
          outlined
          v-if="dashboardStatistics.trip_stats"
        >
          <v-card flat color="secondary lighten-1" class="rounded-lg">
            <v-card-text class="pa-0 white--text">
              <v-row class="ma-0">
                <v-col cols="12" class="pb-0">
                  <span class="text-body-1">
                    {{ tripModule.tripPlural }}
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-icon x-large color="white">mdi-truck-fast</v-icon>
                </v-col>
                <v-col cols="8" class="text-right">
                  <span class="text-h4">
                    {{ dashboardStatistics.trip_stats.total_trips }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card-text class="py-0 px-2">
            <v-row class="ma-0" justify="space-around">
              <v-col cols="6" class="px-1">
                <span class="text-body-2">Created</span>
                <p class="text-h6 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.trip_stats.created_trip }}
                </p>
              </v-col>
              <v-col cols="6"  class="px-1">
                <span class="text-body-2">Closed</span>
                <p class="text-h6 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.trip_stats.closed_trips }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="2"
        class="pl-md-2 pr-md-1 pa-sm-2"
        v-if="dashboardStatistics.orders_stats"
      >
        <v-card flat outlined class="rounded-lg">
          <v-card flat color="secondary lighten-1" class="rounded-lg">
            <v-card-text class="pa-0 white--text">
              <v-row class="ma-0">
                <v-col cols="12" class="pb-0">
                  <span class="text-body-1">{{ orderModule.orderPlural }}</span>
                </v-col>
                <v-col cols="4">
                  <v-icon x-large color="white">mdi-archive</v-icon>
                </v-col>
                <v-col cols="8" class="text-right">
                  <span class="text-h4">
                    {{ dashboardStatistics.orders_stats.total_orders }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card-text class="py-0 px-2">
            <v-row class="ma-0" justify="space-between">
              <v-col cols="6" class="px-1">
                <span class="text-body-2">{{ orderModule.sales }}</span>
                <p class="text-h6 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.orders_stats.sales_orders }}
                </p>
              </v-col>
              <v-col cols="6" class="px-1">
                <span class="text-body-2">{{ orderModule.adhoc }}</span>
                <p class="text-h6 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.orders_stats.total_adhoc_order }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="2" class="pl-md-2 pr-md-1 pa-sm-2">
        <v-card flat outlined class="rounded-lg">
          <v-card flat color="secondary lighten-1" class="rounded-lg">
            <v-card-text class="pa-0 white--text">
              <v-row class="ma-0">
                <v-col cols="12" class="pb-0">
                  <span class="text-body-1">
                    {{ fleetModule.driver }} Utilization
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-icon x-large color="white">mdi-seatbelt</v-icon>
                </v-col>
                <v-col cols="8" class="text-right align-self-end">
                  <span class="text-h6">
                    {{
                      dashboardStatistics.asset_utilization.driver_utilization.toFixed(
                        2
                      )
                    }}%
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card-text class="py-0 px-2">
            <v-row class="ma-0">
              <v-col cols="12" class="px-1">
                <span class="text-body-2">Total {{ fleetModule.driver }}</span>
                <p class="text-h5 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.asset_utilization.total_driver }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="2" class="pl-md-2 pr-md-1 pa-sm-2">
        <v-card flat outlined class="rounded-lg">
          <v-card flat color="secondary lighten-1" class="rounded-lg">
            <v-card-text class="pa-0 white--text">
              <v-row class="ma-0">
                <v-col cols="12" class="pb-0">
                  <span class="text-body-1">
                    {{ fleetModule.vehicle }} Utilization
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-icon x-large color="white">mdi-truck</v-icon>
                </v-col>
                <v-col cols="8" class="text-right align-self-end">
                  <span class="text-h6">
                    {{
                      dashboardStatistics.asset_utilization.vehicle_utilization.toFixed(
                        2
                      )
                    }}%
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card-text class="py-0 px-2">
            <v-row class="ma-0">
              <v-col cols="12" class="px-1">
                <span class="text-body-2">
                  Total {{ fleetModule.vehiclePlural }}
                </span>
                <p class="text-h5 mb-0 primary--text font-weight-bold">
                  {{ dashboardStatistics.asset_utilization.total_vehicle }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="4"
        class="pa-0"
        v-if="
          dashboardStatistics && Object.keys(dashboardStatistics).length > 0
        "
      >
        <v-row class="ma-0">
          <v-col cols="12" md="5" class="pl-1 pr-1 pt-3 pb-1">
            <v-card
              flat
              outlined
              color="secondary lighten-1"
              class="rounded-lg"
            >
              <v-card-text class="white--text px-2 py-3">
                <span class="text-Caption"> Avg. Loading Time </span>
                <p
                  class="text-body-1 font-weight-medium mb-0 mt-2"
                  v-if="dashboardStatistics.trip_stats"
                >
                  {{ dashboardStatistics.trip_stats.average_loading_time }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="7" class="pl-1 pr-2 pt-3 pb-1">
            <v-card
              flat
              outlined
              color="secondary lighten-1"
              class="rounded-lg"
            >
              <v-card-text class="white--text px-2 py-3">
                <span class="text-Caption">
                  Avg. {{ fleetModule.fleet }} Capacity Utilization
                </span>
                <p class="text-body-1 font-weight-medium mb-0 mt-2">
                  {{
                    dashboardStatistics.trip_stats
                      .average_fleet_capacity_utilization
                  }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="pl-1 pr-1 py-1">
            <v-card
              flat
              outlined
              color="secondary lighten-1"
              class="rounded-lg"
            >
              <v-card-text class="white--text px-2 py-3">
                <span class="text-Caption">Avg. Off-loading Time</span>
                <p class="text-body-1 font-weight-medium mb-0 mt-2">
                  {{ dashboardStatistics.trip_stats.average_unloading_time }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="pl-1 pr-2 py-1">
            <v-card
              flat
              outlined
              color="secondary lighten-1"
              class="rounded-lg"
            >
              <v-card-text class="white--text px-2 py-3">
                <span class="text-Caption">Avg. Distance Travelled</span>
                <p class="text-body-1 font-weight-medium mb-0 mt-2">
                  {{ dashboardStatistics.trip_stats.average_distance_travel }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-3">
        <span class="text-h5 font-weight-bold">{{
          tripModule.tripPlural
        }}</span>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="tripChartData && Object.keys(tripChartData).length > 0"
        class="pa-2"
      >
        <v-card flat outlined class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6">Created vs Closed</span>
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="tripChartData"
              :options="tripChartOptions"
              :key="tripChartsKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="
          turnAroundTimeChart && Object.keys(turnAroundTimeChart).length > 0
        "
        class="pa-2"
      >
        <v-card flat outlined class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6">Turn Around Time(TAT)</span>
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="turnAroundTimeChart"
              :options="turnAroundChartOptions"
              :key="turnAroundChartKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-3">
        <span class="text-h5 font-weight-bold">{{
          orderModule.orderPlural
        }}</span>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="px-md-2 pa-sm-2">
        <v-card outlined flat class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6">Created vs Delivered</span>
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="orderCreatedVsDeliveredChart"
              :options="orderCreatedVsDeliveredChartOptions"
              :key="orderCreatedVsDeliveredKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="px-md-2 pa-sm-2">
        <v-card outlined flat class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6"
              >Undelivered {{ orderModule.order }} Reasons</span
            >
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="orderReasonsChart"
              :options="orderReasonsChartOptions"
              :key="orderReasonsChartKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" lg="4" class="px-md-2 pa-sm-2">
        <v-card outlined flat class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6 text-truncate"
              >{{ orderModule.order }} Processing Time vs
              {{ orderModule.order }} Lead Time
            </span>
          </v-card-title>
          <v-card-text>
            <LineChart
              :data="orderProcessingTimeChart"
              :options="orderProcessingTimeChartOptions"
              :key="orderProcessingTimeChartKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-3">
        <span class="text-h5 font-weight-bold">{{ fleetModule.fleets }}</span>
      </v-col>
      <v-col cols="12" md="12" lg="4" class="px-md-2 pa-sm-2">
        <v-card outlined flat class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6">Asset Utilization</span>
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="assetUtilizationChart"
              :options="assetUtilizationChartOptions"
              :key="assetUtilizationChartKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="px-md-2 pa-sm-2">
        <v-card outlined flat class="rounded-lg" min-height="490">
          <v-card-title>
            <span class="text-h6">{{ fleetModule.fleet }} Utilization</span>
          </v-card-title>
          <v-card-text>
            <BarChart
              :data="fleetUtilizationChart"
              :options="fleetUtilizationChartOptions"
              :key="fleetUtilizationChartKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="px-md-2 pa-sm-2 h-100"
        v-if="assetSummary && Object.keys(assetSummary).length > 0"
      >
        <v-card outlined flat class="rounded-lg mx-auto" min-height="490">
          <v-card-title>
            <span class="text-h6">Asset Summary</span>
          </v-card-title>
          <v-card-text>
            <v-row align-content="space-around">
              <v-col cols="6">
                <div class="pa-4 rounded-lg asset-card-border">
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      class="d-flex justify-center align-center pb-4"
                    >
                      <span class="text-body-1 font-weight-bold">
                        Active {{ fleetModule.vehiclePlural }}
                      </span>
                    </v-col>
                    <v-col class="d-flex justify-center align-center py-1">
                      <v-progress-circular
                        :rotate="-90"
                        :size="100"
                        :width="15"
                        :value="
                          assetSummary.vehicle_stats.active_vehicle_percentage
                        "
                        color="primary"
                      >
                        {{
                          assetSummary.vehicle_stats.active_vehicle_percentage.toFixed(
                            2
                          )
                        }}%
                      </v-progress-circular>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="6" class="fill-height">
                <div class="pa-4 rounded-lg asset-card-border">
                  <v-row no-gutters justify="center">
                    <v-col
                      cols="12"
                      class="d-flex justify-center align-center pb-2 text-center"
                    >
                      <span class="text-body-1 font-weight-bold">
                        {{ fleetModule.vehicle }} Stats
                      </span>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <p class="ma-0 text-caption">Active</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.vehicle_stats.active }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <p class="ma-0 text-caption">Inactive</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.vehicle_stats.inactive }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="pt-3 text-center">
                      <p class="ma-0 text-caption">Assigned</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.vehicle_stats.assigned_vehicle }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="pt-3 text-center">
                      <p class="ma-0 text-caption">Unassigned</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.vehicle_stats.unassigned_vehicle }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="pa-4 rounded-lg asset-card-border">
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      class="d-flex justify-center align-center pb-4"
                    >
                      <span class="text-body-1 font-weight-bold">
                        Active {{ fleetModule.driverPlural }}
                      </span>
                    </v-col>
                    <v-col class="d-flex justify-center align-center py-1">
                      <v-progress-circular
                        :rotate="-90"
                        :size="100"
                        :width="15"
                        :value="
                          assetSummary.driver_stats.active_driver_percentage
                        "
                        color="primary"
                      >
                        {{
                          assetSummary.driver_stats.active_driver_percentage.toFixed(
                            2
                          )
                        }}%
                      </v-progress-circular>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="6" class="fill-height">
                <div class="pa-4 rounded-lg asset-card-border">
                  <v-row no-gutters justify="center">
                    <v-col
                      cols="12"
                      class="d-flex justify-center align-center pb-2"
                    >
                      <span class="text-body-1 font-weight-bold">
                        {{ fleetModule.driver }} Stats
                      </span>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <p class="ma-0 text-caption">Active</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.driver_stats.active }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <p class="ma-0 text-caption">Inactive</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.driver_stats.inactive }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="pt-3 text-center">
                      <p class="ma-0 text-caption">Assigned</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.driver_stats.assigned_driver }}
                      </p>
                    </v-col>
                    <v-col cols="6" class="pt-3 text-center">
                      <p class="ma-0 text-caption">Unassigned</p>
                      <p class="ma-0 text--primary font-weight-bold text-h6">
                        {{ assetSummary.driver_stats.unassigned_driver }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { bus } from "@/main.js";
import { getDateTime, returnToday, setChartScales } from "@/utils/functions";
import {
  clientDashboardModule,
  orderModule,
  fleetModule,
  tripModule,
} from "@/utils/moduleMapping";
import BarChart from "@/components/ComponentLibrary/Charts/BarChart.vue";
import LineChart from "@/components/ComponentLibrary/Charts/LineChart.vue";

const defaultObj = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        stacked: true,
      },
    ],
    yAxes: [
      {
        stacked: true,
      },
    ],
  },
};

export default {
  components: { BarChart, LineChart },
  name: "clientIndex",
  data() {
    return {
      clientDashboardModule,
      orderModule,
      fleetModule,
      tripModule,
      items: [
        { text: "Today", value: "today" },
        { text: "Past Seven Days", value: "pastSeven" },
        { text: "Past Month", value: "pastMonth" },
        { text: "Past Three Month", value: "pastThreeMonth" },
      ],
      filters: {
        end_date: new Date().toISOString().slice(0, 10),
      },
      minDate: null,
      maxDate: new Date().toISOString().slice(0, 10),

      dashboardStatistics: {},

      tripChartData: {},
      tripChartsKey: 0,
      tripChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "No. Of Trips"),
      },

      turnAroundTimeChart: {},
      turnAroundChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "Minutes"),
      },
      turnAroundChartKey: 0,

      orderCreatedVsDeliveredChart: {},
      orderCreatedVsDeliveredChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "No. of Orders"),
      },
      orderCreatedVsDeliveredKey: 0,

      orderReasonsChart: {},
      orderReasonsChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "No of Orders"),
      },
      orderReasonsChartKey: 0,

      orderProcessingTimeChart: {},
      orderProcessingTimeChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "No of Minutes"),
      },
      orderProcessingTimeChartKey: 0,

      assetUtilizationChart: {},
      assetUtilizationChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "Utilization"),
      },
      assetUtilizationChartKey: 0,

      fleetUtilizationChart: {},
      fleetUtilizationChartOptions: {
        ...defaultObj,
        ...setChartScales("Date", "Utilization"),
      },
      fleetUtilizationChartKey: 0,

      assetSummary: {},
    };
  },
  computed: {
    todayDate() {
      let newEnd = new Date();
      newEnd.setDate(newEnd.getDate() - 1);
      return newEnd.toISOString().slice(0, 10);
    },
  },
  methods: {
    getDifferenceDate() {
      let date1 = new Date(this.filters.start_date);
      let date2 = new Date(this.filters.end_date);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (7 < diffDays) {
        bus.$emit("showToastMessage", {
          message: "Data can be retrieved for a minimum of seven days ",
          color: "error",
        });
      }
    },
    filterChanged(e) {
      if (e) {
        let startDate;
        let endDate;
        if (e == "today") {
          startDate = returnToday();
          endDate = returnToday();
        } else if (e == "pastSeven") {
          startDate = new Date(returnToday());
          startDate.setDate(startDate.getDate() - 7);
          endDate = returnToday();
        } else if (e == "pastMonth") {
          let date = new Date();
          startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          endDate = new Date(date.getFullYear(), date.getMonth(), 0);
        } else {
          let date = new Date();
          startDate = new Date(date.getFullYear(), date.getMonth() - 3, 1);
          endDate = new Date(date.getFullYear(), date.getMonth(), 0);
        }
        this.filters = {
          start_date: getDateTime(startDate),
          end_date: getDateTime(endDate),
        };
      }
    },
    onStartDateChange(startDate) {
      let today = new Date(startDate);
      today.setDate(today.getDate() + 7);
      this.filters = {
        start_date: startDate,
        end_date: today.toISOString().slice(0, 10),
      };
    },
    onEndDateChange(endDate) {
      let today = new Date(endDate);
      today.setDate(today.getDate() - 7);
      this.filters = {
        start_date: today.toISOString().slice(0, 10),
        end_date: endDate,
      };
    },
    getWeekData() {
      let today = new Date(this.filters.end_date);
      today.setDate(today.getDate() - 7);
      this.filters.start_date = today.toISOString().slice(0, 10);
      if (!this.minDate) {
        this.minDate = this.filters.start_date;
      }
      this.filters = {
        start_date: this.filters.start_date,
        end_date: this.todayDate,
      };
    },
    getDashboardStatistics() {
      this.$api.clientDashboard
        .getClientDashboardSummary(this.filters)
        .then((res) => {
          this.dashboardStatistics = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTripChartData() {
      this.$api.clientDashboard
        .getTripChartData()
        .then((res) => {
          let obj = res.data;
          obj.datasets[1] = {
            ...obj.datasets[1],
            type: "line",
          };
          delete obj.datasets[1]["backgroundColor"];
          this.tripChartData = obj;
          this.tripChartsKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTurnAroundTimeChartData() {
      this.$api.clientDashboard
        .getTurnAroundTimeChartData()
        .then((res) => {
          this.turnAroundTimeChart = res.data;
          this.turnAroundChartKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrderCreatedVsDeliveredChartData() {
      this.$api.clientDashboard
        .getOrderCreatedVsDeliveredChartData()
        .then((res) => {
          this.orderCreatedVsDeliveredChart = res.data;
          this.orderCreatedVsDeliveredKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrderReasonsChartData() {
      this.$api.clientDashboard
        .getOrderReasonsChartData()
        .then((res) => {
          this.orderReasonsChart = res.data;
          this.orderReasonsChartKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrderProcessingTimeChartData() {
      this.$api.clientDashboard
        .getOrderProcessingTimeChartData()
        .then((res) => {
          this.orderProcessingTimeChart = res.data;
          this.orderProcessingTimeChartKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAssetUtilizationChartData() {
      this.$api.clientDashboard
        .getAssetUtilizationChartData()
        .then((res) => {
          this.assetUtilizationChart = res.data;
          this.assetUtilizationChartKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFleetUtilizationChartData() {
      this.$api.clientDashboard
        .getFleetUtilizationChartData()
        .then((res) => {
          this.fleetUtilizationChart = res.data;
          this.fleetUtilizationChartKey++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAssetSummaryData() {
      this.$api.clientDashboard
        .getAssetSummaryData()
        .then((res) => {
          console.log(res);
          this.assetSummary = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async mounted() {
    this.getWeekData();
    this.getDashboardStatistics();
    this.getTripChartData();
    this.getTurnAroundTimeChartData();
    this.getOrderCreatedVsDeliveredChartData();
    this.getOrderReasonsChartData();
    this.getOrderProcessingTimeChartData();
    this.getAssetUtilizationChartData();
    this.getFleetUtilizationChartData();
    this.getAssetSummaryData();
  },
};
</script>
<style scoped>
.dashboard-card-div {
  background-color: var(--v-secondary-lighten1);
  height: 15vh;
}

.asset-card-border {
  border: thin solid #cccccc;
}
</style>
